// extracted by mini-css-extract-plugin
export var component = "hr-module--component--xXHxI";
export var isLeft = "hr-module--isLeft--zgjgt";